import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class UMLDiamondFactory extends AbstractShapeFactory {

  private stroke: number;

  constructor() {
    super();
    this.awType = 'diamond';
    this.parentButton = WBUtils.buttonAdvanced;
  }

  /**
     * Creates and returns a fabric polygon object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    this.stroke = stroke;
    this.shapeObject =  new fabric.Polygon([
      { x: 5, y: 0 },
      { x: 10, y: 5 },
      { x: 5, y: 10 },
      { x: 0, y: 5 }], {
      left: anchorX,
      top: anchorY,
      stroke: color,
      strokeWidth: stroke,
      fill: fill,
    }
    );

    return this.shapeObject;
  }

  /**
     * modifies the polygon object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    const absWidth = Math.abs(anchorX - eventX);

    if (anchorX > eventX) {
      this.shapeObject.set({ left: Math.abs(eventX) });
    }

    if (anchorY > eventY) {
      this.shapeObject.set({ top: Math.abs(eventY) });
    }

    this.shapeObject.scaleToWidth(absWidth);
    this.shapeObject.set({
      strokeWidth: (this.stroke / this.shapeObject.scaleX)
    });
    this.shapeObject.setCoords();
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
